"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)({
  textStyle: {
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': function webkitLineClamp(_ref) {
      var maxRows = _ref.maxRows;
      return maxRows;
    },
    display: '-webkit-box',
    maxWidth: function maxWidth(_ref2) {
      var _maxWidth = _ref2.maxWidth;
      return _maxWidth;
    },
    overflow: 'hidden'
  }
});
var defaultProps = {
  autoTooltip: false,
  classes: {},
  dataMetrics: {
    root: 'fuse_text_wrapper'
  },
  maxRows: 1,
  maxWidth: '100%',
  tooltipText: ''
};

/**
 * Text Wrapper is used when text is too long to display. It will cut excess text off and show ellipsis at the end of the line. While hovering, the full text will be displayed in a tooltip.
 */

var TextWrapper = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref3) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isTextOverflow = _useState2[0],
    setIsTextOverflow = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    localRef = _useState4[0],
    setLocalRef = _useState4[1];
  var autoTooltip = props.autoTooltip,
    children = props.children,
    classes = props.classes,
    className = props.className,
    dataMetrics = props.dataMetrics,
    maxRows = props.maxRows,
    maxWidth = props.maxWidth,
    tooltipText = props.tooltipText,
    tooltipConfig = props.tooltipConfig;

  // combine tooltip props
  var tooltipProps = _objectSpread({
    title: autoTooltip && !isTextOverflow ? '' : tooltipText
  }, tooltipConfig);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var _useStyles = useStyles({
      maxRows: maxRows,
      maxWidth: maxWidth
    }),
    textStyle = _useStyles.textStyle;
  (0, _react.useEffect)(function () {
    if (localRef) {
      setIsTextOverflow(localRef.scrollHeight > localRef.clientHeight);
    }
  }, [children, localRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-metrics": mergedDataMetrics.root
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], tooltipProps, /*#__PURE__*/_react["default"].createElement("span", {
    ref: function ref(rawRef) {
      if (_ref3) _ref3.current = rawRef; /* eslint-disable-line no-param-reassign */
      setLocalRef(rawRef);
    },
    className: (0, _classnames["default"])(textStyle, className, classes.textContainer)
  }, children)));
});
TextWrapper.defaultProps = defaultProps;
TextWrapper.displayName = 'TextWrapper';
TextWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If true, show tooltip when text is overflowing. If false, always show tooltip.
   */
  autoTooltip: _propTypes["default"].bool,
  /**
   * Text that needs to be wrapped.
   */
  children: _propTypes["default"].element.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].shape({
    root: _propTypes["default"].string,
    textContainer: _propTypes["default"].string
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Max rows for text, default to 1(single line).
   */
  maxRows: _propTypes["default"].number,
  /**
   * Customize max width of text area, unit is required.
   */
  maxWidth: _propTypes["default"].string,
  /**
   * Override or extend the styles applied to the tooltip.
   */
  tooltipConfig: _propTypes["default"].object,
  /**
   * Tooltip text. A zero-length string will cause tooltip disabled.
   */
  tooltipText: _propTypes["default"].node
} : {};
var _default = TextWrapper;
exports["default"] = _default;